export const typeRatingsTable = [
  {
    itemLabel: 'NONE',
    itemValue: 'NONE',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DO-328',
    itemValue: 'DO-328',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'D328JET',
    itemValue: 'D328JET',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'SN-601',
    itemValue: 'SN-601',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'A-340',
    itemValue: 'A-340',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BD500',
    itemValue: 'BD500',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CA-212',
    itemValue: 'CA-212',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'C-295',
    itemValue: 'C-295',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'A-300',
    itemValue: 'A-300',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'A-310',
    itemValue: 'A-310',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'A-320',
    itemValue: 'A-320',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'A-330',
    itemValue: 'A-330',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'A-350',
    itemValue: 'A-350',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'A-380',
    itemValue: 'A-380',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'L-420',
    itemValue: 'L-420',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'ATR-42, ATR-72',
    itemValue: 'ATR-42, ATR-72',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BAE-146, AVR-146',
    itemValue: 'BAE-146, AVR-146',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'B-17',
    itemValue: 'B-17',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'B-247',
    itemValue: 'B-247',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'B-307',
    itemValue: 'B-307',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'B-314',
    itemValue: 'B-314',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'B-377',
    itemValue: 'B-377',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'B-707, B-720',
    itemValue: 'B-707, B-720',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'B-727',
    itemValue: 'B-727',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'B-737',
    itemValue: 'B-737',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'B-747',
    itemValue: 'B-747',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'B-747-4',
    itemValue: 'B-747-4',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'B-757, B-767',
    itemValue: 'B-757, B-767',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'B-777',
    itemValue: 'B-777',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'B-787',
    itemValue: 'B-787',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DC-3',
    itemValue: 'DC-3',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DC-3S',
    itemValue: 'DC-3S',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DC-3TP',
    itemValue: 'DC-3TP',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DC-4',
    itemValue: 'DC-4',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DC-6, DC-7',
    itemValue: 'DC-6, DC-7',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DC-8',
    itemValue: 'DC-8',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DC-9',
    itemValue: 'DC-9',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DC-10',
    itemValue: 'DC-10',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'MD-11',
    itemValue: 'MD-11',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CL-30',
    itemValue: 'CL-30',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BBD-700',
    itemValue: 'BBD-700',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'G7500',
    itemValue: 'G7500',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CL-44',
    itemValue: 'CL-44',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CL-65',
    itemValue: 'CL-65',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CL-66',
    itemValue: 'CL-66',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CL-600',
    itemValue: 'CL-600',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CL-604',
    itemValue: 'CL-604',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DHC-8',
    itemValue: 'DHC-8',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BG-905',
    itemValue: 'BG-905',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BR-305',
    itemValue: 'BR-305',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'AW-650',
    itemValue: 'AW-650',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BAE-ATP',
    itemValue: 'BAE-ATP',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BAE-125',
    itemValue: 'BAE-125',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BA-3100',
    itemValue: 'BA-3100',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BA-4100',
    itemValue: 'BA-4100',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CONCRD',
    itemValue: 'CONCRD',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BA-111',
    itemValue: 'BA-111',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BU-2000',
    itemValue: 'BU-2000',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BD500',
    itemValue: 'BD500',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'YC-122',
    itemValue: 'YC-122',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'SF-50',
    itemValue: 'SF-50',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CW-46',
    itemValue: 'CW-46',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DA-7X',
    itemValue: 'DA-7X',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DA-10',
    itemValue: 'DA-10',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DA-20',
    itemValue: 'DA-20',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DA-50',
    itemValue: 'DA-50',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DA-200',
    itemValue: 'DA-200',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DA-2000',
    itemValue: 'DA-2000',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DA-EASY',
    itemValue: 'DA-EASY',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DA-2EASY',
    itemValue: 'DA-2EASY',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'HW-500',
    itemValue: 'HW-500',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DC-A20',
    itemValue: 'DC-A20',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DC-A24',
    itemValue: 'DC-A24',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DC-B18',
    itemValue: 'DC-B18',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DC-B23',
    itemValue: 'DC-B23',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DC-2',
    itemValue: 'DC-2',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DC-B26',
    itemValue: 'DC-B26',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'EA-500',
    itemValue: 'EA-500',
    singlePilot: 'EA-500S',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'EMB-110',
    itemValue: 'EMB-110',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'EMB-120',
    itemValue: 'EMB-120',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'EMB-145',
    itemValue: 'EMB-145',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'EMB-500',
    itemValue: 'EMB-500',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'EMB-505',
    itemValue: 'EMB-505',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'EMB-550',
    itemValue: 'EMB-550',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'ERJ-170, ERJ-190',
    itemValue: 'ERJ-170, ERJ-190',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'F-27',
    itemValue: 'F-27',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'FA-119C',
    itemValue: 'FA-119C',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'FA-C123',
    itemValue: 'FA-C123',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'C-82A',
    itemValue: 'C-82A',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'FK-28',
    itemValue: 'FK-28',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'FK-100',
    itemValue: 'FK-100',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'FO-5',
    itemValue: 'FO-5',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CV-PB2Y',
    itemValue: 'CV-PB2Y',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CV-P4Y',
    itemValue: 'CV-P4Y',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CV-PBY5',
    itemValue: 'CV-PBY5',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CV-LB30',
    itemValue: 'CV-LB30',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CV-240, CV-340, CV-440',
    itemValue: 'CV-240, CV-340, CV-440',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CV-A340, CV-A440',
    itemValue: 'CV-A340, CV-A440',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CV-600, CV-640',
    itemValue: 'CV-600, CV-640',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CV-880, CV-990',
    itemValue: 'CV-880, CV-990',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CV-N1, CV-N2',
    itemValue: 'CV-N1, CV-N2',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'G-S2',
    itemValue: 'G-S2',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'G-TBM',
    itemValue: 'G-TBM',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'G-111',
    itemValue: 'G-111',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'G-73',
    itemValue: 'G-73',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'G-73T',
    itemValue: 'G-73T',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'G-159',
    itemValue: 'G-159',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'G-1159',
    itemValue: 'G-1159',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'G-IV',
    itemValue: 'G-IV',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'G-V',
    itemValue: 'G-V',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'GVI',
    itemValue: 'GVI',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'GVII',
    itemValue: 'GVII',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'IA-1125, G-100',
    itemValue: 'IA-1125, G-100',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'G150',
    itemValue: 'G150',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'G-200',
    itemValue: 'G-200',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'G280',
    itemValue: 'G280',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'HF-320',
    itemValue: 'HF-320',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'HP-300',
    itemValue: 'HP-300',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'Y-12F',
    itemValue: 'Y-12F',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'HS-106',
    itemValue: 'HS-106',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'HS-114',
    itemValue: 'HS-114',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'HS-748',
    itemValue: 'HS-748',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'HA-420',
    itemValue: 'HA-420',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'IA-JET',
    itemValue: 'IA-JET',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'IA-101',
    itemValue: 'IA-101',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'AD-4N',
    itemValue: 'AD-4N',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'LR-JET',
    itemValue: 'LR-JET',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'LR-45',
    itemValue: 'LR-45',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'LR-60',
    itemValue: 'LR-60',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'L-P2V',
    itemValue: 'L-P2V',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'L-14',
    itemValue: 'L-14',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'L-18',
    itemValue: 'L-18',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'L-B34',
    itemValue: 'L-B34',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'L-P38',
    itemValue: 'L-P38',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'L-300',
    itemValue: 'L-300',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'EC-130Q',
    itemValue: 'EC-130Q',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'L-1011',
    itemValue: 'L-1011',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'L-1049',
    itemValue: 'L-1049',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'L-1329',
    itemValue: 'L-1329',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'T-33',
    itemValue: 'T-33',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'L-188',
    itemValue: 'L-188',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'L-382',
    itemValue: 'L-382',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'L-382J',
    itemValue: 'L-382J',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'L-382J-1',
    itemValue: 'L-382J-1',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'SA-227',
    itemValue: 'SA-227',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'M-B26',
    itemValue: 'M-B26',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'M-PBM5',
    itemValue: 'M-PBM5',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'M-202, M-404',
    itemValue: 'M-202, M-404',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'MS-760',
    itemValue: 'MS-760',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'YS-11',
    itemValue: 'YS-11',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'ND-262',
    itemValue: 'ND-262',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'NH-P61',
    itemValue: 'NH-P61',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'P-808',
    itemValue: 'P-808',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'PC-24',
    itemValue: 'PC-24',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'PA-42R',
    itemValue: 'PA-42R',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'PZL-M28',
    itemValue: 'PZL-M28',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DO-228',
    itemValue: 'DO-228',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'N-B25',
    itemValue: 'N-B25',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'SA-2000',
    itemValue: 'SA-2000',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'SF-340',
    itemValue: 'SF-340',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'N-265',
    itemValue: 'N-265',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'SK-43',
    itemValue: 'SK-43',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'SK-44',
    itemValue: 'SK-44',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'S-210',
    itemValue: 'S-210',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'SJ30',
    itemValue: 'SJ30',
    singlePilot: 'SJ30S',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CE-500',
    itemValue: 'CE-500',
    singlePilot: 'CE-500',
    singlePilotRemarks: 'C501,C551 only',
  },
  {
    itemLabel: 'CE-560XL',
    itemValue: 'CE-560XL',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CE-510',
    itemValue: 'CE-510',
    singlePilot: 'CE-510S',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CE-525',
    itemValue: 'CE-525',
    singlePilot: 'CE-525S',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CE-650',
    itemValue: 'CE-650',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CE680',
    itemValue: 'CE680',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CE-700',
    itemValue: 'CE-700',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CE-750',
    itemValue: 'CE-750',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BE-200',
    itemValue: 'BE-200',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BE-300',
    itemValue: 'BE-300',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BE-1900',
    itemValue: 'BE-1900',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BE-2000',
    itemValue: 'BE-2000',
    singlePilot: 'BE-2000S',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'MU-300, BE-400',
    itemValue: 'MU-300, BE-400',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'HS-125',
    itemValue: 'HS-125',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BAE-125',
    itemValue: 'BAE-125',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'RA-390',
    itemValue: 'RA-390',
    singlePilot: 'RA-390S',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'RA-4000',
    itemValue: 'RA-4000',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'VC-700, VC-800',
    itemValue: 'VC-700, VC-800',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CL-215',
    itemValue: 'CL-215',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'CL-415',
    itemValue: 'CL-415',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DHC-4',
    itemValue: 'DHC-4',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DHC-6',
    itemValue: 'DHC-6',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DHC-6HG',
    itemValue: 'DHC-6HG',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'DHC-7',
    itemValue: 'DHC-7',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'SD-3',
    itemValue: 'SD-3',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'SK-56',
    itemValue: 'SK-56',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'EC225LP',
    itemValue: 'EC225LP',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'S-330',
    itemValue: 'S-330',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'AS332E',
    itemValue: 'AS332E',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BH-14',
    itemValue: 'BH-14',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BH-14ST',
    itemValue: 'BH-14ST',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'S-70',
    itemValue: 'S-70',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BV-234',
    itemValue: 'BV-234',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BV-44',
    itemValue: 'BV-44',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'SK-58',
    itemValue: 'SK-58',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'SK-64',
    itemValue: 'SK-64',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'S-321',
    itemValue: 'S-321',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'SK-65',
    itemValue: 'SK-65',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'BV-107',
    itemValue: 'BV-107',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'AB-139, AW-139',
    itemValue: 'AB-139, AW-139',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'AW189',
    itemValue: 'AW189',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'SK-61',
    itemValue: 'SK-61',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'SK-92',
    itemValue: 'SK-92',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
  {
    itemLabel: 'H46E',
    itemValue: 'H46E',
    singlePilot: 'NONE',
    singlePilotRemarks: 'NONE',
  },
];

export const engineTypes = [
  { itemValue: '0', itemLabel: 'None' },
  { itemValue: '1', itemLabel: 'Reciprocating' },
  { itemValue: '10', itemLabel: 'Electric' },
  { itemValue: '11', itemLabel: 'Rotary' },
  { itemValue: '2', itemLabel: 'Turbo-prop' },
  { itemValue: '3', itemLabel: 'Turbo-shaft' },
  { itemValue: '4', itemLabel: 'Turbo-jet' },
  { itemValue: '5', itemLabel: 'Turbo-fan' },
  { itemValue: '6', itemLabel: 'Ramjet' },
  { itemValue: '7', itemLabel: '2 Cycle' },
  { itemValue: '8', itemLabel: '4 Cycle' },
];

export const aircraftTypes = [
  { itemValue: '1', itemLabel: 'Glider' },
  { itemValue: '2', itemLabel: 'Balloon' },
  { itemValue: '3', itemLabel: 'Blimp/Dirigible' },
  { itemValue: '4', itemLabel: 'Fixed wing single engine' },
  { itemValue: '5', itemLabel: 'Fixed wing multi engine' },
  { itemValue: '6', itemLabel: 'Rotorcraft' },
  { itemValue: '7', itemLabel: 'Weight-shift-control' },
  { itemValue: '8', itemLabel: 'Powered Parachute' },
  { itemValue: '9', itemLabel: 'Gyroplane' },
  { itemValue: 'H', itemLabel: 'Hybrid Lift' },
  { itemValue: 'O', itemLabel: 'Other' },
];
